import { useEffect, useRef, useState } from 'react';

// 타입
import { ISearchInput } from './type';

// 아이콘
import CoreSvg from '../CoreSvg';

// 스타일드 컴포넌트
import {
	InputWrapper,
	InputBoxWrapper,
	SearchInputBox,
	IconWrapper,
	IconFocusWrapper,
	LabelText,
	HelperText,
} from './style';
import { useTheme } from 'styled-components';
import Icon from 'shared/icons';

const CoreSearchInput = ({
	input_id,
	is_error = false,
	_placeholder,
	_disabled = false,
	label,
	helper,
	_defaultValue,
	_value,
	_ref,
	_wrapper_ref,
	_width,
	_onClick,
	_onClickButton,
	_onChange,
	_margin,
	focus = false,
}: ISearchInput) => {
	const [button_size, setButtonSize] = useState(0);
	// input의 DOM
	const inputbox_ref = useRef<HTMLInputElement>(null);
	const close_button_ref = useRef<HTMLButtonElement>(null);

	// input에 focus 되어있는가의 여
	// const [focus, setFocus] = useInputFocus(close_button_ref, inputbox_ref, []);

	// input창 클릭 시 커서가 입력한 제일 마지막 값으로 이동하는 커스텀 훅
	// useMoveLast(_ref ?? inputbox_ref);

	useEffect(() => {
		if (close_button_ref.current === null) setButtonSize(0);

		const target = close_button_ref.current?.getElementsByTagName('button')?.[0];

		if (!target) return;

		setButtonSize(target.offsetWidth);
	}, [close_button_ref]);

	const theme = useTheme();

	return (
		<InputWrapper onClick={_onClick} _width={_width} _margin={_margin} ref={_wrapper_ref}>
			<LabelText input_id={input_id} is_label={label ? true : false}>
				{label}
			</LabelText>
			<InputBoxWrapper
				onClick={() => {
					inputbox_ref.current?.focus();
				}}
			>
				<IconWrapper>
					<CoreSvg _fill={theme.colors.gray.gray80_text}>
						<Icon.Search />
					</CoreSvg>
				</IconWrapper>
				<SearchInputBox
					placeholder={_placeholder}
					disabled={_disabled}
					id={input_id}
					is_error={is_error}
					ref={_ref ?? inputbox_ref}
					button_size={button_size > 0 ? button_size : false}
					value={_value}
					defaultValue={_defaultValue}
					onChange={_onChange}
					autoComplete="off"
					// onClick={() => setFocus(true)}
				/>
				<IconFocusWrapper
					is_focus={focus}
					ref={close_button_ref}
					onClick={() => {
						// setFocus(true);
						_onClickButton && _onClickButton();
						// setFocus(false);
					}}
				>
					<CoreSvg _fill={theme.colors.gray.gray80_text}>
						<Icon.CloseCircle />
					</CoreSvg>
				</IconFocusWrapper>
			</InputBoxWrapper>
			{helper && <HelperText is_error={is_error ? 'true' : 'false'}>{helper}</HelperText>}
		</InputWrapper>
	);
};

export default CoreSearchInput;

// 추가 수정 필요
